// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608201511/js/" + chunkId + "." + {"44":"29e42803","225":"5f86fac9","481":"82094e48","486":"ae8df589","770":"8bc90ea9"}[chunkId] + ".0.7226587136085553.chunk.js";
};